import { useState } from "react";
import { Modal, Form, Input, message, Select } from "antd";
import axios from "axios";
import { useAuth0 } from "../../react-auth0-spa";
import { useAppContext } from "../../context";
import config from "../../api_config.json";
import createFeatureMutation from "./queries/createFeatureMutation";

const PLAN_OPTIONS = [
  { label: "Base", value: "base" },
  { label: "Verificato", value: "verified" },
  { label: "Premium", value: "premium" },
];

const CreateFeatureModal = ({ visible, onCancel, onCreate }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();

      setLoading(true);

      const token = await getTokenSilently();
      const graphqlUrl = `${config.baseUrl[env]}/graphql?raw=true`;

      const fields = {
        name: values.name,
        label: values.label || "",
        description: values.description || "",
        plans: values.plans || [],
        ACL: {
          public: {
            read: true,
            write: false,
          },
        },
      };

      await axios.post(
        graphqlUrl,
        {
          query: createFeatureMutation,
          variables: { fields },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      message.success("Feature creata con successo");
      form.resetFields();
      onCreate();
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      console.error("Error creating feature:", error);
      message.error("Errore durante la creazione della feature");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Crea Nuova Feature"
      open={visible}
      onOk={handleCreate}
      onCancel={handleCancel}
      okText="Crea"
      cancelText="Annulla"
      confirmLoading={loading}
      width={500}
      maskClosable={false}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Nome (chiave)"
          name="name"
          rules={[{ required: true, message: "Il nome e' obbligatorio" }]}
        >
          <Input placeholder="es: directory, bio, gallery, shop" />
        </Form.Item>

        <Form.Item label="Label" name="label">
          <Input placeholder="es: Presenza in directory" />
        </Form.Item>

        <Form.Item label="Descrizione" name="description">
          <Input.TextArea
            placeholder="Descrizione della feature"
            rows={3}
          />
        </Form.Item>

        <Form.Item label="Piani inclusi" name="plans">
          <Select
            mode="multiple"
            placeholder="Seleziona i piani che includono questa feature"
            options={PLAN_OPTIONS}
            allowClear
          />
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default CreateFeatureModal;
